import { ABOUTUSCONTENT_GET_LIST } from "../../../redux/contants";


// eslint-disable-next-line import/prefer-default-export
export const getAboutUsContent = (data) => ({
    type: ABOUTUSCONTENT_GET_LIST,
    payload: data
});
